"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Jwt = void 0;
const helpers_1 = require("./helpers");
class Jwt {
    constructor() {
        //TODO: to pass audience secret
        this.audience_secret = "";
    }
    generate_jwt(tgt, payloadBasic) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!payloadBasic.sub || !payloadBasic.aud || !payloadBasic.at0) {
                throw new Error("missing payload details");
            }
            const payload = payloadBasic;
            const headerEncoded = this.getHeaderPart();
            const payloadEncoded = this.getPayloadPart(payload);
            const header_dot_payload = `${headerEncoded}.${payloadEncoded}`;
            const secret = yield this.generate_token_secret(payload, tgt, this.audience_secret);
            const signature = (0, helpers_1.b64_safe)(yield (0, helpers_1.hmac)(secret, header_dot_payload));
            return `${header_dot_payload}.${signature}`;
        });
    }
    generate_token_secret(payloadBasic, tgt, audience_secret) {
        return __awaiter(this, void 0, void 0, function* () {
            const { aud, rnd, at0 } = payloadBasic;
            const key = tgt;
            const msg = `${aud}.${audience_secret}.${rnd}.${at0}`;
            // console.log(aud, rnd, at0, tgt, "sec", audience_secret);
            return (0, helpers_1.b64_safe)(yield (0, helpers_1.hmac)(key, msg));
        });
    }
    getHeaderPart() {
        const header = { alg: "HS256", typ: "JWT" };
        return (0, helpers_1.b64_safe)((0, helpers_1.atob64)(JSON.stringify(header)));
    }
    getPayloadPart(payloadBasic) {
        const payload = payloadBasic;
        const is_logged_in = (typeof (payload.sub) === 'number');
        payload.rnd = is_logged_in ? (0, helpers_1.rnd)(5) : (0, helpers_1.rnd)(10);
        payload.exp = parseInt(String(Date.now() / 1000)) + 300;
        return (0, helpers_1.b64_safe)((0, helpers_1.atob64)(JSON.stringify(payload)));
    }
}
exports.Jwt = Jwt;
